import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type { Price} from "@@/shared/prices/price";
import { priceZodSchema } from "@@/shared/prices/price";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { ShippingId} from "../shipping-id";
import { shippingIdZodSchema } from "../shipping-id";

type SetShippingZonePriceCommand = {
    readonly _id: string;
    readonly _type: "SET_SHIPPING_ZONE_PRICE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly shippingId: ShippingId;
    readonly zoneId: string;
    readonly price: Price;
};

type FactoryParams = Except<
    SetShippingZonePriceCommand,
    "_id" | "_type" | "_createdAt"
>;
const createSetShippingZonePriceCommand = (params: FactoryParams) => {
    const command: SetShippingZonePriceCommand = {
        ...params,
        _id: generateId({ prefix: "set_shipping_zone_price_command__" }),
        _type: "SET_SHIPPING_ZONE_PRICE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const setShippingZonePriceCommandIdZodSchema = idZodSchema.regex(
    /^set_shipping_zone_price_command__.*$/,
);

const setShippingZonePriceCommandZodSchema: z.ZodSchema<SetShippingZonePriceCommand> =
    z.object({
        _id: setShippingZonePriceCommandIdZodSchema,
        _type: z.literal("SET_SHIPPING_ZONE_PRICE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        shippingId: shippingIdZodSchema,
        zoneId: z.string(),
        price: priceZodSchema,
    });

export {
    createSetShippingZonePriceCommand,
    setShippingZonePriceCommandZodSchema,
};
export type { SetShippingZonePriceCommand };
